import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-payment-success-template',
  templateUrl: './payment-success-template.component.html',
  styleUrls: ['./payment-success-template.component.scss']
})
export class PaymentSuccessTemplateComponent implements OnInit {
  @Input() rowOne = {
    successLogo: null,
    successMsg: null,
    successInfoMsg: null
  };

  @Input() rowTwo = [
    { rowName: null, rowValue: null },
    { rowName: null, rowValue: null },
    { rowName: null, rowValue: null },
  ];

  @Output() buttonClickedHandler: EventEmitter<string> = new EventEmitter<string>();

  @Input() templateButtonText: string = '';
  @Input() isComingFromPartnerRetailer: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  buttonHandler() {
    this.buttonClickedHandler.emit('borrower');
  }

}
